import { render } from "./Footer.vue?vue&type=template&id=90dd29a6"
const script = {}

import exportComponent from "/home/runner/work/stc-frontend/stc-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__